import { render, staticRenderFns } from "./TatHistoryDialog.vue?vue&type=template&id=c950f756"
import script from "./TatHistoryDialog.vue?vue&type=script&lang=js"
export * from "./TatHistoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports